exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "body[data-nav-overflow] .mobile-controls{display:flex;align-items:center}body[data-nav-overflow] .top-bar-links{display:none!important}body[data-nav-overflow] .nav .vn-family.d-block.d-md-none{display:block!important}", ""]);

// exports
